import { httpGet, httpPost } from "@/utils/http";

// 登录接口
export const loginApi = (params) => {
  return httpPost("/api/user/checkIn", params);
};

// 手机短信登录
export const mobileLoginApi = (params) => {
  return httpPost("/api/user/mobileCheckIn", params);
};

// 获取用户信息
export const getUserInfoApi = (params) => {
  return httpGet("/api/user/info", params);
};

// 获取权限菜单 
export const getMenuListApi = (params) => {
  return httpGet("/api/common/getMenuList", params);
};

/** 获取可以购买的会员列表 */
export const getMemberListApi = (params) => {
  return httpGet("/api/product.vip/index", params);
};

/** 创建订单 */
export const createOrderApi = (params) => {
  return httpPost("/api/product.order/order", params);
}; 

/** 创建二维码 */
export const createQrCodeApi = (params) => {
  return httpGet("/api/product.order/payByWechatQrCode", params);
};

/** 根据订单号 查询订单状态 */ 
export const getOrderStatusApi = (params) => {
  return httpGet("/api/product.order/getStatus", params);
};
